const CONTEXT = /^\/c\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\/|$)/i;

export function createManagementScope(readPath) {
  const prefix = () => { const match = readPath().match(CONTEXT); return match ? `/c/${match[1]}` : ''; };
  const initial = prefix();
  let revision = 0;
  return {
    prefix: initial,
    apiBase: `${initial}/api`,
    capture: () => ({prefix:initial, revision}),
    invalidate: () => { revision += 1; },
    assertCurrent(snapshot) {
      if (snapshot.prefix !== initial || snapshot.revision !== revision || prefix() !== initial) {
        const error = new Error('管理上下文已变更，已丢弃旧请求结果。');
        error.code = 'CONTEXT_CHANGED';
        throw error;
      }
    },
  };
}

// 一个文档只承载一个管理上下文，跨来源链接必须完整导航。
export const managementScope = createManagementScope(() => globalThis.window?.location.pathname || '/');
